import api from "services/api";
import serveRequestErrors from "common/serve-request-errors";

const getEmploymentEndStatusListing = async () => {
	let response = null;
	let errorMessage = null;

	try {
		const params = { lookupHdrId: "EMPLOYMENT_STATUS_END", sort: "seq,asc" };
		const res = await api.get.general.list(params);
		const content = res.map(({ lookupTitle, lookupValue, ...o }) => ({ ...o, label: lookupTitle, value: lookupValue }));
		response = { content };
	} catch (error) {
		errorMessage = serveRequestErrors(error);
	}

	if (response) return response;

	throw errorMessage;
};

export default getEmploymentEndStatusListing;
